"use client";

import Modal from '@/components/modal';
import { useRef } from 'react';
import HcpClinicalInformationDoseReductionsModal from './components/modal';
import HcpClinicalInformationDoseReductionsVersion1 from './components/version-1';
import HcpClinicalInformationDoseReductionsVersion2 from './components/version-2';
import styles from './_dose-reductions.module.scss';

export default function HcpClinicalInformationDoseReductions({ index = 0 }) {
  const modalRef = useRef(null);

  return (
    <>
      {index === 0 && <HcpClinicalInformationDoseReductionsVersion1 modalRef={modalRef} />}
      {index === 1 && <HcpClinicalInformationDoseReductionsVersion2 modalRef={modalRef} />}
      <Modal ref={modalRef} customClass={styles.modal}>
        <HcpClinicalInformationDoseReductionsModal index={index}/>
      </Modal>
    </>
  );
}
